import React, { FC, memo } from 'react'

import {
    Container,
    ContentWrapper,
    HeaderSection,
    SectionTitle,
    HighlightedReviewerName,
    LastUpdated,
    ReviewerSection,
    ReviewerImageWrapper,
    ReviewerInfo,
    ReviewerName,
    ReviewerDescription,
} from './styles'
import { ReviewContentTransport } from '../../../transports/region-landing-page-transport'
import ImageLoadingComponent from '../../app-components/image-loading-component'
import { useTranslation } from '../../../hooks/locale'

interface ReviewContentSectionProps {
    reviewContentSection: ReviewContentTransport
}

const ReviewContentSection: FC<ReviewContentSectionProps> = ({ reviewContentSection }) => {
    const { t } = useTranslation()
    const { reviewerImage, reviewedBy, updatedOn, content } = reviewContentSection
    const imageUrl = reviewerImage?.formats?.large?.url || reviewerImage?.url

    if (!reviewedBy || !content) {
        return null
    }

    return (
        <Container id="review-content">
            <ContentWrapper>
                <HeaderSection>
                    <SectionTitle>
                        {t('contentReviewedBy')} <HighlightedReviewerName>{reviewedBy}</HighlightedReviewerName>
                    </SectionTitle>
                    {updatedOn && (
                        <LastUpdated>
                            {t('lastUpdatedOn')} {updatedOn}
                        </LastUpdated>
                    )}
                </HeaderSection>

                <ReviewerSection>
                    {imageUrl && (
                        <ReviewerImageWrapper>
                            <ImageLoadingComponent
                                src={imageUrl}
                                alt={reviewedBy || t('contentReviewer')}
                                objectFit="cover"
                                borderRadius="50%"
                            />
                        </ReviewerImageWrapper>
                    )}
                    <ReviewerInfo>
                        <ReviewerName>{reviewedBy}</ReviewerName>
                        <ReviewerDescription>{content}</ReviewerDescription>
                    </ReviewerInfo>
                </ReviewerSection>
            </ContentWrapper>
        </Container>
    )
}

export default memo(ReviewContentSection)
